import { PageMeta, PageRequest } from '@/app/core/models/paged-result.model';
import { toBffRut } from '@/app/shared/utils/rut.utils';
import {
  StaffMemberRecord,
  StaffVigenteCriteria,
  StaffVigentePage,
} from '../models/staff-vigente.model';
import {
  StaffApiPaginationMeta,
  StaffVigenteApiItem,
  StaffVigenteApiResponse,
} from './staff-vigente-api.types';

const ONE_INDEXED_OFFSET = 1;

export function toApiPage(page: PageRequest): number {
  return page.page + ONE_INDEXED_OFFSET;
}
export function hasValue<T extends string | number>(value: T | undefined): value is T {
  return value !== undefined && value !== ('' as T);
}

function setIfPresent(
  params: Record<string, string | number>,
  key: string,
  value: string | number | undefined,
): void {
  if (hasValue(value)) params[key] = value;
}

export function toApiQueryParams(
  criteria: StaffVigenteCriteria,
  page: PageRequest,
): Record<string, string | number> {
  return { ...toApiFilterParams(criteria), page: toApiPage(page), limit: page.size };
}

export function toApiFilterParams(criteria: StaffVigenteCriteria): Record<string, string | number> {
  const params: Record<string, string | number> = { tipo: criteria.type };
  setIfPresent(params, 'rut', criteria.rut && toBffRut(criteria.rut));
  setIfPresent(params, 'nombres', criteria.names);
  setIfPresent(params, 'apellidoPaterno', criteria.lastNamePaternal);
  setIfPresent(params, 'apellidoMaterno', criteria.lastNameMaternal);
  setIfPresent(params, 'idEspecialidad', criteria.specialtyId);
  setIfPresent(params, 'idGlosaDireccion', criteria.addressId);
  setIfPresent(params, 'canal', criteria.channel);
  return params;
}

export function toPageMeta(meta: StaffApiPaginationMeta): PageMeta {
  return {
    page: meta.page - ONE_INDEXED_OFFSET,
    size: meta.limit,
    totalElements: meta.totalRegistros,
    totalPages: meta.totalPaginas,
  };
}

export function toStaffMemberRecord(item: StaffVigenteApiItem): StaffMemberRecord {
  return {
    providerRut: item.rutPrestador,
    addressLabel: item.glosaDireccion,
    addressId: item.idGlosaDireccion,
    specialty: item.especialidad,
    specialtyId: item.idEspecialidad,
    rut: item.rutMedico,
    name: item.nombreMedico,
    attentionScope: item.ambito,
    sisRegistrationNumber: item.numeroRegistroSis,
    channel: item.canal,
    healthConditionIds: item.problemaDeSalud,
  };
}

export function toStaffVigentePage(response: StaffVigenteApiResponse): StaffVigentePage {
  return {
    content: response.data.map(toStaffMemberRecord),
    page: toPageMeta(response.meta),
  };
}
